import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { Redirect, Link } from "react-router-dom";
import apiUrl from "../apiUrlConstant";
import * as Yup from "yup";
import { Alert } from "react-bootstrap";
import { PopupMessage } from "../utils/utils";
import TopHeader from "../layout/TopHeader";
const loginForm = Yup.object().shape({
  old_password: Yup.string().required("Required"),
  password: Yup.string().required("Required"),
  cpassword: Yup.string()
    .required("Required")
    .oneOf([Yup.ref("password"), null], "Passwords must match"),
});

class UserResetPassword extends React.Component {
  state = {
    redirect: false,
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    showLoader: false,
    errorMessage: "",
    showAlert: false,
    setShow: false,
    showHeader: true,
  };

  componentDidMount() {
    if (
      typeof localStorage.getItem("TOKEN") == "undefined" ||
      localStorage.getItem("TOKEN") == null ||
      localStorage.getItem("TOKEN") == "null"
    ) {
      this.setState({ showHeader: false });
    }
  }

  constructor(props) {
    super(props);
  }
  redirectAfterSave = () => {
    this.setState({ redirect: true, messsagePopup: false });
  };

  render() {
    //console.log(this.props.match,"this.props.match.params.token");

    if (this.state.redirect == true) {
      let url = this.props.match;
      this.state.redirect = false;
      return <Redirect push to="/masters" />;
    }
    return (
      <div
        className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <div>
        {this.state.showHeader === true && <TopHeader />}
        <div className="absoluteItemForTopBar left20px">
          <Link to={`/lease-summary`} className="">
            <img src="/img/logo.png" className="headerLogo" />
          </Link>
        </div>

        <Formik
          validationSchema={loginForm}
          initialValues={{
            password: "",
            cpassword: "",
            old_password: "",
          }}
          onSubmit={(values, actions) => {
            var ths = this;
            this.setState({ showLoader: true });
            var self = this;
            axios({
              method: "post",
              url: `${apiUrl.apiUrl.url}/user/change-password`,
              data: values,
            }).then(function (response) {
              self.setState({ showLoader: false });
              if (!response.data.result) {
                actions.setSubmitting(false);
                actions.setErrors(response.data);
              } else {
                if (response.data.result == "fail") {
                  actions.setErrors(response.data.errors);
                } else {
                  // alert("Password changed successfully.");
                  // self.setState({ redirect: true });
                  self.setState({
                    messsagePopup: true,
                    popupContent: "Password changed successfully.",
                  });
                }
              }
            });
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,

            resetForm,
          }) => (
            <>
              <div className="loginMainPage" style={{ backgroundImage: `url("/img/loginBackground.jpg")` }}>
                <Form autoComplete="off">
                  <div className="text-center">
                    <Link to={`/lease-summary`} className="">
                      <img src="/img/logo.png" className="logoImg" />
                    </Link>
                    <p className="tagLine text-center">
                      TAKE CONTROL OF YOUR REAL ESTATE
                    </p>
                  </div>
                  <div>
                    <Alert
                      variant="danger"
                      onClose={() => this.setState({ showAlert: false })}
                      dismissible
                      show={this.state.showAlert}
                    >
                      <Alert.Heading>
                        {this.state.errorMessage}
                      </Alert.Heading>
                    </Alert>
                    <div className="formInner mb-4">
                      <label >
                        Old Password <span>*</span>
                      </label>
                      <div className="position-relative">
                        <Field type="password" name="old_password" />
                        <ErrorMessage
                          name="old_password"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="formInner mb-3">
                      <label>
                        New Password <span>*</span>
                      </label>
                      <div className="position-relative">
                        <Field type="password" name="password" />
                        <ErrorMessage
                          name="password"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="formInner mb-3">
                      <label>
                        Confirm Password <span>*</span>
                      </label>
                      <div className="position-relative">
                        <Field type="password" name="cpassword" />
                        <ErrorMessage
                          name="cpassword"
                          component="div"
                          className="text-red"
                        />
                      </div>
                    </div>
                    <div className="formInner">
                      {this.state.showLoader && (
                        <p
                          className="text-center mb-0"
                          style={{ fontWeight: "600" }}
                        >
                          <img src="/img/loading.gif" width={"80px"} />
                        </p>
                      )}
                      <button
                        type="submit"
                        className="loginBtn"
                        value="LOGIN"
                        onClick={(e) => {
                          this.setState({ showAlert: false });
                        }}
                      >
                        Change Password
                      </button>
                    </div>
                  </div>
                  <div className="madeByPart mt-5 text-center">
                    <p className="">Made By</p>
                    <p className="marginBottom-0">
                      <img src="/img/cre-matrix-logo.png" />
                    </p>
                  </div>
                </Form>
                <PopupMessage
                  open={this.state.messsagePopup}
                  content={this.state.popupContent}
                  redirectAfterSave={this.redirectAfterSave}
                />
              </div>

              {/* <div className="unitFormContainer login">
                <div className="container">
                  <div className="row"></div>
                </div>
                <div>
                  <div></div>
                </div>
                <Form autoComplete="off" >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-4 mx-auto">
                        <div className="formContainer">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <h1 className="text-center">
                              <Link to={`/lease-summary`} className="">
                                <img src="/img/logo.png" className="logoImg" />
                              </Link>
                            </h1>
                            <Alert
                              variant="danger"
                              onClose={() => this.setState({ showAlert: false })}
                              dismissible
                              show={this.state.showAlert}
                            >
                              <Alert.Heading>
                                {this.state.errorMessage}
                              </Alert.Heading>
                            </Alert>
                            <div className="row mb-3">
                              <label className="col-sm-12 col-form-label">
                                Old Password <span>*</span>
                              </label>
                              <div className="col-sm-12">
                                <Field type="password" name="old_password" />
                                <ErrorMessage
                                  name="old_password"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-12 col-form-label">
                                New Password <span>*</span>
                              </label>
                              <div className="col-sm-12">
                                <Field type="password" name="password" />
                                <ErrorMessage
                                  name="password"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-12 col-form-label">
                                Confirm Password <span>*</span>
                              </label>
                              <div className="col-sm-12">
                                <Field type="password" name="cpassword" />

                                <ErrorMessage
                                  name="cpassword"
                                  component="div"
                                  className="text-red"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="inputContainer col-lg-12 col-md-12 marginBottom-0">
                            <div className="row">
                              <div className="col-sm-12">
                                {this.state.showLoader && (
                                  <p
                                    className="text-center mb-0"
                                    style={{ fontWeight: "600" }}
                                  >
                                    <img src="/img/loading.gif" width={"80px"} />
                                  </p>
                                )}
                                <button
                                  type="submit"
                                  className="loginBtn"
                                  value="LOGIN"
                                  onClick={(e) => {
                                    this.setState({ showAlert: false });
                                  }}
                                >
                                  Change Password
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
                <PopupMessage
                  open={this.state.messsagePopup}
                  content={this.state.popupContent}
                  redirectAfterSave={this.redirectAfterSave}
                />
              </div> */}
            </>
          )}
        </Formik>
      </div>
    );
  }
}

export default UserResetPassword;
